import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCopy(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 2.5a2.75 2.75 0 0 0-2.75 2.75V6H5.5a2.75 2.75 0 0 0-2.75 2.75v10A2.75 2.75 0 0 0 5.5 21.5h9a2.75 2.75 0 0 0 2.75-2.75V18h1.25a2.75 2.75 0 0 0 2.75-2.75v-10A2.75 2.75 0 0 0 18.5 2.5zm7.75 14h1.25c.69 0 1.25-.56 1.25-1.25v-10c0-.69-.56-1.25-1.25-1.25h-9c-.69 0-1.25.56-1.25 1.25V6h6.25a2.75 2.75 0 0 1 2.75 2.75zm-13-7.75c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-9c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  }));
}
var IcCopy = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCopy));

export { IcCopy as I };
